export const cloneTracker = (trackerInstance, usageTrackerLocation) => {
  return trackerInstance.clone({
    preserveTrackerEvents: true,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation
    }
  });
};